// popup.js
import React from "react";
import Popup from "reactjs-popup";
import { XCircle } from 'react-feather';
import { useCookies } from "../utils/useCookies"


interface MacAppProps {   
  isOpen: boolean
}

export const MacAppPopup: React.FC<MacAppProps> = ({ isOpen }, props) => {

  const [opened, setOpened] = React.useState(false)
  const [isFirstOpen, setIsFirstOpen] = React.useState(true)
  const [getCookie, setCookie,] = useCookies();
  const [dismissMacApp, setDismissMacApp] = React.useState(!window?.newFlow && !getCookie("dismissMacApp"))
  const [showMacApp, setShowMacApp] = React.useState(!window?.newFlow && !getCookie("showMacApp"))
  const [showTutorial] = React.useState(!window?.newFlow && !getCookie("showTour"));

  const close = () => {
    setCookie("showMacApp", false, 1)    
    setOpened(false)
  }
  const open = () => {    
    setOpened(true)
  }
  const dismissModal = () => {   
    setCookie("dismissMacApp", false, 365)          
    setOpened(false)
  }

  React.useEffect(() => {
      
      if(isFirstOpen && isOpen && showMacApp && dismissMacApp && !showTutorial){       
        setTimeout(() => {
          let platform = navigator?.userAgentData?.platform || navigator?.platform              
          if(platform && platform.toLowerCase().includes("mac")){            
            setIsFirstOpen(false)
            setOpened(true)
            
          }
          
        }, 1000);
        
      }
  }, [opened])

  return <Popup contentStyle={{ width: "450px", height:"385px" }} 
            onOpen={open}
            position="top center"         
            open={opened} onClose={close} modal={false} closeOnDocumentClick={true} closeOnEscape={true}>
            {
              <div className="view-macapp">
                <span className="close" onClick={close}>
                      <XCircle className="feather" />
                </span>  
                <br></br>
                <h2>Do you know we have a Mac app?</h2>
                <br></br>
                <a href="https://flowvella.com/download?from=modal" target="_blank" onClick={() => {
                    close()
                }}>
                  <img src="/include/img/logos/flowvella-mac-2022.png" width={100}/>
                </a>
                  <br></br><br></br>
                <a href="https://flowvella.com/download?from=modal" target="_blank"  onClick={() => {
                    close()
                }}>
                  <h2>Download it here!</h2>
                </a>
                <br></br>
                <h4><span className="emphasized" >Don't tell anyone, but it's better than our web version</span></h4>
                <br></br>
                <h5><a onClick={() => {
                    dismissModal()
                }}>Do not show again</a></h5>
              </div>
            }
        </Popup>
}